import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { selectCurrentPhone } from '../../containers/App/selectors'
import { selectDevicesFetching } from '../../containers/DeviceSelector/selectors'

const DeviceNotLoadedHOC = WrappedComponent => {
  const DeviceNotLoaded = ({
    currentPhone,
    devicesFetching,
    ...parentProps
  }) => {
    const deviceInvalid = () => {
      return currentPhone === undefined || devicesFetching === false
    }

    return (
      <WrappedComponent
        {...parentProps}
        currentPhone={currentPhone}
        devicesFetching={devicesFetching}
        deviceInvalid={deviceInvalid}
      />
    )
  }

  const mapStateToProps = state => ({
    currentPhone: selectCurrentPhone(state),
    devicesFetching: selectDevicesFetching(state)
  })

  return connect(mapStateToProps)(DeviceNotLoaded)
}

export default DeviceNotLoadedHOC



// WEBPACK FOOTER //
// ./src/hocs/DeviceNotLoadedHOC/index.js